module.exports = "<div class=\"container mt-5 pt-5\" [innerHtml]=\"myTemplate\"></div>\n\n<div *ngIf=\"this.Config.cackleOn\" class=\"container mt-5 pt-5 comment\">\n  <div class=\"text-content\">\n    <h3>Комментарии:</h3>\n    <div id=\"mc-container\"></div>\n    <div class=\"comment-sign\">\n      <a id=\"mc-link\" href=\"http://cackle.me\">Комментарии для сайта <b style=\"color:#4FA3DA\">Cackl</b><b style=\"color:#F65077\">e</b></a>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/blog-pages/blog-pages.component.html
// module id = ./src/app/landing/info/blog-pages/blog-pages.component.html
// module chunks = main